// Helper function to convert cents to dollars
function centsToDollars(centsValue) {
  let dollarValue = centsValue / 100;
  return dollarValue.toFixed(2);
}

// Enable in DevTools: window.strikethroughDebug = true
function strikethroughLog(label, detail) {
  if (window.strikethroughDebug) {
    if (detail !== undefined) {
      console.log('[strikethrough]', label, detail);
    } else {
      console.log('[strikethrough]', label);
    }
  }
}

function strikethroughWarn(label, detail) {
  if (detail !== undefined) {
    console.warn('[strikethrough]', label, detail);
  } else {
    console.warn('[strikethrough]', label);
  }
}

// Always logged — use to confirm the updated script is loaded on the storefront
function strikethroughInfo(label, detail) {
  if (detail !== undefined) {
    console.info('[strikethrough]', label, detail);
  } else {
    console.info('[strikethrough]', label);
  }
}

function logCartLinePriceDebug(phase, detail) {
  if (!window.strikethroughDebug) return;
  if (detail !== undefined) {
    console.log('[strikethrough cart]', phase, detail);
  } else {
    console.log('[strikethrough cart]', phase);
  }
}

function summarizeCartLinePrices() {
  return Array.from(document.querySelectorAll('.cart-item.strikethrough-enabled')).map((item) => ({
    id: item.id,
    productType: item.dataset.productType,
    loading: isCartItemPriceLoading(item),
    prices: Array.from(item.querySelectorAll('.dynamic-price'))
      .filter((el) => el.tagName !== 'S')
      .map((el) => ({
        added: el.classList.contains('dynamic-price-added'),
        visible: cartLineMemberPriceIsVisible(el, item),
        location: el.closest('.cart-item__totals') ? 'line-total' : 'line-details',
        text: el.textContent.trim().slice(0, 40),
        hasMemberDiscount: Boolean(el.parentElement?.querySelector('.dynamic-price-discounted')),
      })),
  }));
}

function cartLineMemberPriceIsVisible(priceEl, cartItem) {
  if (priceEl.tagName === 'S') return true;

  if (priceEl.closest('.discounted')) {
    return priceEl.classList.contains('dynamic-price-added');
  }

  const parent = priceEl.parentElement;
  const hasStrike = Boolean(priceEl.querySelector('s'));
  const discountEl = parent?.querySelector('.dynamic-price-discounted');
  const hasDiscount = Boolean(discountEl?.textContent?.trim());

  if (!hasStrike || !hasDiscount) return false;

  if (cartItem && priceEl.closest('.cart-item__totals')) {
    return cartLineTotalMemberPriceIsCorrect(cartItem, priceEl.closest('.cart-item__totals'), getStrikethroughData());
  }

  return true;
}

function getCartLineMemberDiscountCents(cartItem, data, originalLineCents) {
  if (!cartItem.classList.contains('strikethrough-enabled')) return originalLineCents;
  if (cartItem.dataset.isPromotionalItem === 'true') {
    const finalFromData = parseInt(cartItem.dataset.finalLineCents, 10);
    return isNaN(finalFromData) ? originalLineCents : finalFromData;
  }

  const productTypeKey = normalizeProductTypeKey(cartItem.dataset.productType || '');
  const productDiscount = getStrikethroughProductDiscount(data, productTypeKey);
  if (!productDiscount) return originalLineCents;

  const memberDiscountCents = dollarsToCents(priceCalc(productDiscount, originalLineCents));
  const finalFromData = parseInt(cartItem.dataset.finalLineCents, 10);
  const resolvedFinalCents = isNaN(finalFromData) ? originalLineCents : finalFromData;

  if (resolvedFinalCents > 0 && resolvedFinalCents < memberDiscountCents) {
    return resolvedFinalCents;
  }

  return memberDiscountCents;
}

function cartLineTotalMemberPriceIsCorrect(cartItem, totalsCell, data) {
  if (!data || !cartItem?.classList.contains('strikethrough-enabled')) return true;
  if (!totalsCell || isHiddenCartColumn(totalsCell)) return true;

  const originalLineCents = parseInt(cartItem.dataset.originalLineCents, 10);
  if (isNaN(originalLineCents) || originalLineCents <= 0) return true;

  const expectedDiscountCents = getCartLineMemberDiscountCents(cartItem, data, originalLineCents);
  if (expectedDiscountCents >= originalLineCents) return true;

  const priceWrapper = totalsCell.querySelector('.cart-item__price-wrapper');
  if (!priceWrapper) return false;

  const discountEl = priceWrapper.querySelector('.dynamic-price-discounted');
  const strikeEl = priceWrapper.querySelector('s');
  if (!discountEl || !strikeEl) return false;

  const shownDiscountCents = dollarsToCents(discountEl.textContent.trim());
  const shownOriginalCents = dollarsToCents(strikeEl.textContent.trim());

  return shownDiscountCents === expectedDiscountCents && shownOriginalCents === originalLineCents;
}

function applyCartLineTotalMemberPrice(cartItem, data) {
  if (!cartItem.classList.contains('strikethrough-enabled')) return false;

  const totalsCell = cartItem.querySelector('.cart-item__totals');
  if (!totalsCell || isHiddenCartColumn(totalsCell)) return false;
  if (isCartItemPriceLoading(cartItem)) return false;

  const originalLineCents = parseInt(cartItem.dataset.originalLineCents, 10);
  if (isNaN(originalLineCents) || originalLineCents <= 0) return false;

  const expectedDiscountCents = getCartLineMemberDiscountCents(cartItem, data, originalLineCents);
  if (expectedDiscountCents >= originalLineCents) return false;

  if (cartLineTotalMemberPriceIsCorrect(cartItem, totalsCell, data)) return false;

  const priceWrapper = totalsCell.querySelector('.cart-item__price-wrapper');
  if (!priceWrapper) return false;

  const unitPrice = priceWrapper.querySelector('.unit-price');
  const variantTitle =
    cartItem.querySelector('.cart-item__details .dynamic-price')?.dataset?.variantTitle ||
    cartItem.querySelector('.cart-item__totals .dynamic-price')?.dataset?.variantTitle ||
    '';

  const originalDisplay = window.currency.symbol + centsToDollars(originalLineCents);
  const discountedDisplay = window.currency.symbol + centsToDollars(expectedDiscountCents);
  const priceColor = data.strikethrough_price_colors[data.customer.customer_swell_tier];

  priceWrapper.innerHTML = '';

  const priceContainer = document.createElement('span');
  priceContainer.classList.add('price', 'price--end');

  const priceEl = document.createElement('span');
  priceEl.classList.add('dynamic-price', 'dynamic-price-added', 'dynamic-price-final');
  if (variantTitle) priceEl.dataset.variantTitle = variantTitle;

  const strikeWrap = document.createElement('span');
  const strikeEl = document.createElement('s');
  strikeEl.classList.add('cart-item__old-price');
  strikeEl.textContent = originalDisplay;
  strikeWrap.appendChild(strikeEl);
  priceEl.appendChild(strikeWrap);

  const discountEl = document.createElement('span');
  discountEl.classList.add('me-1', 'dynamic-price-discounted', 'dynamic-price-final');
  discountEl.style.color = priceColor;
  discountEl.textContent = discountedDisplay;

  priceContainer.appendChild(priceEl);
  priceContainer.appendChild(discountEl);
  priceWrapper.appendChild(priceContainer);

  if (unitPrice) priceWrapper.appendChild(unitPrice);

  logCartLinePriceDebug('applied-line-total', {
    id: cartItem.id,
    originalCents: originalLineCents,
    discountedCents: expectedDiscountCents,
    discountedDisplay,
  });

  return true;
}

function applyCartLineTotalPrices(data) {
  const stats = { applied: 0, skipped: 0, deferred: 0 };

  document.querySelectorAll('.cart-item.strikethrough-enabled').forEach((cartItem) => {
    if (isCartItemPriceLoading(cartItem)) {
      stats.deferred++;
      return;
    }

    if (applyCartLineTotalMemberPrice(cartItem, data)) {
      stats.applied++;
    } else {
      stats.skipped++;
    }
  });

  if (stats.applied > 0 || stats.deferred > 0) {
    strikethroughInfo('cart line total updates', stats);
  }

  if (stats.deferred > 0) {
    setTimeout(() => applyCartLineTotalPrices(data), 250);
  }
}

function restoreCartLinePriceElement(priceEl, cartItem) {
  priceEl.classList.remove('dynamic-price-added');

  const parent = priceEl.parentElement;
  parent?.querySelectorAll('.dynamic-price-discounted').forEach((el) => el.remove());

  const struck = priceEl.querySelector('s');
  if (struck) {
    priceEl.textContent = struck.textContent.trim();
    return;
  }

  if (priceEl.closest('.cart-item__totals') && cartItem) {
    const lineCents = parseInt(cartItem.dataset.originalLineCents, 10);
    if (!isNaN(lineCents) && lineCents > 0) {
      priceEl.textContent = window.currency.symbol + centsToDollars(lineCents);
    }
  }
}

function normalizeSwellTier(tierName) {
  const tier = (tierName || 'regular').toLowerCase().trim();
  if (tier.includes('vip')) return 'vip';
  if (tier.includes('insider')) return 'insider';
  return 'regular';
}

function getStrikethroughProductDiscount(data, productTypeKey) {
  const tierTypes = data.strikethrough_product_types?.[data.customer.customer_swell_tier];
  if (!tierTypes) return null;
  return tierTypes[productTypeKey] || null;
}

function isHiddenCartColumn(element) {
  return element.closest('.medium-hide, .small-hide, .large-up-hide, .hidden, [hidden]') !== null;
}

function normalizeProductTypeKey(productType) {
  return productType.toLowerCase().replace(/ /g, '_').replace(/\./g, '_');
}

function getCartLineOriginalCents(totalsCell) {
  const struck = totalsCell.querySelector('s');
  if (struck) return dollarsToCents(struck.textContent.trim());

  const dynamicPrice = totalsCell.querySelector('.dynamic-price');
  if (dynamicPrice) {
    const struckInPrice = dynamicPrice.querySelector('s');
    if (struckInPrice) return dollarsToCents(struckInPrice.textContent.trim());

    const priceText = dynamicPrice.textContent.trim();
    if (priceText) return dollarsToCents(priceText);
  }

  const finalEl = totalsCell.querySelector('.dynamic-price-final:not(.dynamic-subtotal-discounted)');
  if (finalEl) return dollarsToCents(finalEl.textContent.trim());

  return 0;
}

function getCartLineDiscountedCents(cartItem, totalsCell, data) {
  const originalFromData = parseInt(cartItem.dataset.originalLineCents, 10);
  const finalFromData = parseInt(cartItem.dataset.finalLineCents, 10);

  if (!isNaN(originalFromData) && !isNaN(finalFromData)) {
    return getCartLineDiscountedCentsFromRow(cartItem, data, originalFromData, finalFromData);
  }

  if (!cartItem.classList.contains('strikethrough-enabled')) {
    const finalEl = totalsCell.querySelector('.dynamic-price-final:not(.dynamic-subtotal-discounted)');
    if (finalEl) return dollarsToCents(finalEl.textContent.trim());
    return getCartLineOriginalCents(totalsCell);
  }

  const productTypeKey = normalizeProductTypeKey(cartItem.dataset.productType || '');
  const productDiscount = getStrikethroughProductDiscount(data, productTypeKey);

  // strikethroughLog('cart line discount lookup', {
  //   productType: cartItem.dataset.productType,
  //   productTypeKey,
  //   swellTier: data.customer.customer_swell_tier,
  //   productDiscount,
  // });

  if (!productDiscount) return getCartLineOriginalCents(totalsCell);

  const originalCents = getCartLineOriginalCents(totalsCell);
  if (!originalCents) return 0;

  return dollarsToCents(priceCalc(productDiscount, originalCents));
}

function getCartItemsRoot(cartContainer) {
  if (!cartContainer) return null;

  return (
    cartContainer.querySelector('#CartDrawer-CartItems') ||
    cartContainer.querySelector('#main-cart-items') ||
    cartContainer.querySelector('cart-drawer-items') ||
    (cartContainer.matches('cart-items, cart-drawer-items') ? cartContainer : null) ||
    cartContainer
  );
}

function getCartContainerForSubtotal(subtotal) {
  const cartDrawer = subtotal.closest('cart-drawer');
  if (cartDrawer) return cartDrawer;

  const mainFooter = subtotal.closest('#main-cart-footer');
  if (mainFooter) {
    return document.querySelector('cart-items') || mainFooter;
  }

  return document.querySelector('cart-drawer') || document.querySelector('cart-items');
}

function getCartLineCentsFromRow(cartItem, data) {
  const originalFromData = parseInt(cartItem.dataset.originalLineCents, 10);
  const finalFromData = parseInt(cartItem.dataset.finalLineCents, 10);

  if (!isNaN(originalFromData)) {
    const originalCents = originalFromData;
    const finalCents = isNaN(finalFromData) ? originalCents : finalFromData;
    const discountedCents = getCartLineDiscountedCentsFromRow(cartItem, data, originalCents, finalCents);
    return { originalCents, discountedCents };
  }

  const totalsCell = cartItem.querySelector('.cart-item__totals');
  if (!totalsCell || isHiddenCartColumn(totalsCell)) return null;

  const originalCents = getCartLineOriginalCents(totalsCell);
  const discountedCents = getCartLineDiscountedCents(cartItem, totalsCell, data);
  return { originalCents, discountedCents };
}

function getCartLineDiscountedCentsFromRow(cartItem, data, originalCents, finalCents) {
  const resolvedFinalCents = isNaN(finalCents) ? originalCents : finalCents;

  if (cartItem.dataset.isPromotionalItem === 'true') {
    return resolvedFinalCents;
  }

  if (!cartItem.classList.contains('strikethrough-enabled')) {
    return resolvedFinalCents;
  }

  const productTypeKey = normalizeProductTypeKey(cartItem.dataset.productType || '');
  const productDiscount = getStrikethroughProductDiscount(data, productTypeKey);

  if (!productDiscount) {
    return resolvedFinalCents;
  }

  const memberDiscountedCents = dollarsToCents(priceCalc(productDiscount, originalCents));

  // Prefer the better (lower) of Shopify's applied price vs member price.
  // Includes $0 Shopify discounts — previously `> 0` skipped those and used member instead.
  if (!isNaN(resolvedFinalCents) && resolvedFinalCents < originalCents) {
    return Math.min(resolvedFinalCents, memberDiscountedCents);
  }

  return memberDiscountedCents;
}

function renderSubtotalCompareAt(subtotal, originalTotalCents, discountedTotalCents, options = {}) {
  if (!subtotal) return false;
  if (isNaN(originalTotalCents) || isNaN(discountedTotalCents)) return false;
  if (!originalTotalCents || discountedTotalCents >= originalTotalCents) return false;

  const priceWrapper = document.createElement('span');
  priceWrapper.classList.add('price', 'price--end', 'strikethrough-subtotal-prices');

  const discountElement = document.createElement('span');
  discountElement.classList.add('dynamic-subtotal-discounted', 'price--new', 'dynamic-price-final');
  if (options.priceColor) {
    discountElement.style.color = options.priceColor;
  }
  discountElement.textContent = window.currency.symbol + centsToDollars(discountedTotalCents);

  const sTag = document.createElement('s');
  sTag.classList.add('cart-item__old-price');
  sTag.textContent = window.currency.symbol + centsToDollars(originalTotalCents);

  priceWrapper.appendChild(discountElement);
  priceWrapper.appendChild(sTag);

  subtotal.classList.remove('dynamic-subtotal-added');
  subtotal.replaceChildren(priceWrapper);
  subtotal.classList.add('dynamic-subtotal-added');

  return true;
}

function applySubtotalStrikethrough(subtotal, data, index) {
  const cartContainer = getCartContainerForSubtotal(subtotal);

  if (!cartContainer) {
    strikethroughInfo('subtotal skipped', { reason: 'no cart container' });
    return;
  }

  const itemsRoot = getCartItemsRoot(cartContainer);
  if (!itemsRoot) {
    strikethroughInfo('subtotal skipped', { reason: 'no cart items root' });
    return;
  }

  let originalTotalCents = 0;
  let discountedTotalCents = 0;
  let lineCount = 0;

  itemsRoot.querySelectorAll('.cart-item').forEach((cartItem) => {
    const lineCents = getCartLineCentsFromRow(cartItem, data);
    if (!lineCents) return;

    originalTotalCents += lineCents.originalCents;
    discountedTotalCents += lineCents.discountedCents;
    lineCount += 1;
  });

  if (!lineCount) {
    cartContainer.querySelectorAll('.cart-item').forEach((cartItem) => {
      const lineCents = getCartLineCentsFromRow(cartItem, data);
      if (!lineCents) return;

      originalTotalCents += lineCents.originalCents;
      discountedTotalCents += lineCents.discountedCents;
      lineCount += 1;
    });
  }

  if (!lineCount) {
    strikethroughInfo('subtotal skipped', { reason: 'no cart lines' });
    return;
  }

  const datasetOriginalCents = parseInt(subtotal.dataset.originalLineTotalCents, 10);
  if (!isNaN(datasetOriginalCents) && datasetOriginalCents > originalTotalCents) {
    originalTotalCents = datasetOriginalCents;
  }

  const cartTotalCents = parseInt(subtotal.dataset.cartTotalCents, 10);
  if (!isNaN(cartTotalCents) && cartTotalCents >= 0 && cartTotalCents < originalTotalCents) {
    // Never show a member subtotal higher than what Shopify will charge.
    discountedTotalCents = Math.min(discountedTotalCents || cartTotalCents, cartTotalCents);
  }

  if (discountedTotalCents >= originalTotalCents) {
    strikethroughInfo('subtotal skipped', {
      reason: 'no discount difference',
      originalTotalCents,
      discountedTotalCents,
      lineCount,
    });
    return;
  }

  strikethroughInfo('subtotal applied', {
    original: window.currency.symbol + centsToDollars(originalTotalCents),
    discounted: window.currency.symbol + centsToDollars(discountedTotalCents),
    cartTotalCents,
    lines: lineCount,
  });

  const priceColor = data?.strikethrough_price_colors?.[data.customer?.customer_swell_tier];
  renderSubtotalCompareAt(subtotal, originalTotalCents, discountedTotalCents, {
    priceColor,
  });
}

function subTotalUpdates(data) {
  // strikethroughLog('subTotalUpdates called', {
  //   swellTier: data.customer.customer_swell_tier,
  //   subtotalCount: document.querySelectorAll('.dynamic-subtotal').length,
  // });

  document.querySelectorAll('.dynamic-subtotal').forEach((subtotal, index) => {
    applySubtotalStrikethrough(subtotal, data, index);
  });
}

function formatDiscountBadgeLabel(productDiscount) {
  if (!productDiscount?.value) return '';

  const value = String(productDiscount.value).trim();
  if (!value) return '';

  if (productDiscount.type === 'percentage') {
    const percentage = value.includes('%') ? value.replace('%', '').trim() : value;
    return `Save ${percentage}%`;
  }

  const moneyValue = value.startsWith('$') ? value : `$${value}`;
  return `Save ${moneyValue}`;
}

function getTierBadgeLabel(tier) {
  if (tier === 'vip') return 'VIP price';
  if (tier === 'insider') return 'Insider price';
  return 'Member price';
}

function getStrikethroughBadgeMessage(data, card) {
  const customMessage = (card.dataset.strikethoughMessage || '').trim();
  if (customMessage) return customMessage;

  const tier = data.customer.customer_swell_tier;
  const productTypeKey = normalizeProductTypeKey(card.dataset.productType || '');
  const productDiscount = getStrikethroughProductDiscount(data, productTypeKey);
  const discountLabel = formatDiscountBadgeLabel(productDiscount);

  if (discountLabel) return discountLabel;

  return getTierBadgeLabel(tier);
}

function updateBadge(data, card) {
  const badgeMessage = getStrikethroughBadgeMessage(data, card);
  if (!badgeMessage) return;

  var badge_holders = card.querySelectorAll('.card__badge');
  badge_holders.forEach(holder => {
    if(holder.classList.contains('dynamic-tag-added')) return;

    var badgeElement = document.createElement("span");
    badgeElement.classList.add('badge', 'badge-strikethrough');
    badgeElement.style.backgroundColor = data.strikethrough_badge_colors[data.customer.customer_swell_tier];
    badgeElement.style.border = '1px solid ' + data.strikethrough_badge_colors[data.customer.customer_swell_tier];
    badgeElement.style.color = '#FFF'
    badgeElement.innerHTML = badgeMessage;
    holder.prepend( badgeElement );

    holder.classList.add('dynamic-tag-added');
  })
  
}

function isStrikethroughSurfaceEnabled(data, surface) {
  const surfaces = data?.strikethrough_surfaces;
  // Older cached sessions may omit surfaces — treat missing as enabled.
  if (!surfaces || typeof surfaces !== 'object') return true;
  return surfaces[surface] !== false;
}

function isCartStrikethroughSurfaceOn(data = getStrikethroughData() || window.strikethrough) {
  return isStrikethroughSurfaceEnabled(data, 'cart');
}

/** True when cart member pricing can actually run (surface on + a customer type enabled). */
function isCartStrikethroughConfigured(data = getStrikethroughData() || window.strikethrough) {
  if (!isCartStrikethroughSurfaceOn(data)) return false;
  if (data?.strikethrough_enable_logged_out) return true;
  const types = data?.strikethrough_customer_types;
  return Array.isArray(types) && types.length > 0;
}

/** Member cart pricing is active only when configured AND the customer is eligible. */
function isCartStrikethroughActive(data = getStrikethroughData()) {
  if (!data) return false;
  if (!isCartStrikethroughConfigured(data)) return false;
  return eligibilityCheck(data);
}

function getStrikethroughSurfaceForHost(host) {
  if (!host) return null;
  if (host.classList.contains('cart-item')) return 'cart';
  if (host.matches?.('product-info') || host.tagName === 'PRODUCT-INFO') return 'product_page';
  if (host.classList.contains('card')) return 'product_cards';
  return null;
}

function applyStrikethroughBadges(data) {
  const enableBadge = data.strikethrough_badge_enable?.[data.customer.customer_swell_tier];
  if (!enableBadge) return;

  // Cart lines with Shopify-discounted unit prices only have <s class="dynamic-price">,
  // which priceUpdates skips — so badges must be applied independently.
  document
    .querySelectorAll(
      '.card.strikethrough-enabled, .cart-item.strikethrough-enabled, product-info.strikethrough-enabled'
    )
    .forEach((host) => {
      const surface = getStrikethroughSurfaceForHost(host);
      if (surface && !isStrikethroughSurfaceEnabled(data, surface)) return;
      updateBadge(data, host);
    });
}

function priceUpdates(data) {
  const cartApplyStats = { applied: 0, skipped: 0, reapplied: 0 };

  if (isStrikethroughSurfaceEnabled(data, 'product_cards')) {
    var no_price_cards = document.querySelectorAll('.card.strikethrough-enabled-no-price');
    no_price_cards.forEach(card => {
      var enable_badge = data.strikethrough_badge_enable[data.customer.customer_swell_tier];
      if(enable_badge) updateBadge(data, card);
    });
  }

  var prices = document.querySelectorAll('.dynamic-price');

  prices.forEach((price) => {
    if (price.tagName === 'S') return;

    var closest_card =
      price.closest('.card.strikethrough-enabled') ||
      price.closest('.cart-item.strikethrough-enabled') ||
      price.closest('product-info.strikethrough-enabled');

    if (!price || !closest_card) return;

    const surface = getStrikethroughSurfaceForHost(closest_card);
    if (surface && !isStrikethroughSurfaceEnabled(data, surface)) return;

    const isCartLine = closest_card.classList.contains('cart-item');

    if (isCartLine && price.closest('.cart-item__totals')) {
      cartApplyStats.skipped++;
      logCartLinePriceDebug('skip-line-total-deferred', { id: closest_card.id });
      return;
    }

    if (isCartLine && price.closest('.cart-item__totals') && isCartItemPriceLoading(closest_card)) {
      cartApplyStats.skipped++;
      logCartLinePriceDebug('skip-loading-spinner', { id: closest_card.id });
      return;
    }

    var enable_badge = data.strikethrough_badge_enable[data.customer.customer_swell_tier];
    if (enable_badge) updateBadge(data, closest_card);

    if (price.classList.contains('dynamic-price-added')) {
      if (isCartLine && !cartLineMemberPriceIsVisible(price, closest_card)) {
        strikethroughWarn('cart line member price stale → re-applying', {
          id: closest_card.id,
          location: price.closest('.cart-item__totals') ? 'line-total' : 'line-details',
          text: price.textContent.trim(),
        });
        restoreCartLinePriceElement(price, closest_card);
        if (isCartLine) cartApplyStats.reapplied++;
      } else {
        if (isCartLine) cartApplyStats.skipped++;
        logCartLinePriceDebug('skip-already-added', {
          id: closest_card.id,
          text: price.textContent.trim(),
        });
        return;
      }
    }

    var productTypeKey = normalizeProductTypeKey(closest_card.dataset.productType || '');
    var product_discount_object = getStrikethroughProductDiscount(data, productTypeKey);
    if (!product_discount_object) {
      if (isCartLine) cartApplyStats.skipped++;
      logCartLinePriceDebug('skip-no-discount', {
        id: closest_card.id,
        productType: closest_card.dataset.productType,
        productTypeKey,
        tier: data.customer.customer_swell_tier,
      });
      return;
    }

    const priceValueInCents = getDynamicPriceCents(price, isCartLine ? closest_card : null);
    if (!priceValueInCents) {
      if (isCartLine) cartApplyStats.skipped++;
      logCartLinePriceDebug('skip-no-price-cents', {
        id: closest_card.id,
        text: price.textContent.trim(),
        html: price.innerHTML.trim().slice(0, 120),
      });
      return;
    }

    const priceValue = priceValueInCents / 100;
    const price_object_discounted = price.closest('.discounted') ? true : false;

    if (price_object_discounted) {
      closest_card
        .querySelectorAll('.price--new')
        .forEach((priceElement) => {
          priceElement.style.color = data.strikethrough_price_colors[data.customer.customer_swell_tier];
        });
      price.classList.add('dynamic-price-added');
      if (isCartLine) cartApplyStats.applied++;
      logCartLinePriceDebug('applied-discounted-block', { id: closest_card.id, cents: priceValueInCents });
    } else {
      let priceText = price.textContent.trim();
      let fromPrefix = priceText.startsWith('from ') ? 'from ' : '';

      let strikeElement = document.createElement('s');
      strikeElement.textContent = window.currency.symbol + priceValue.toFixed(2);

      let wrapperElement = document.createElement('span');
      wrapperElement.appendChild(document.createTextNode(fromPrefix));
      wrapperElement.appendChild(strikeElement);

      price.textContent = '';
      price.appendChild(wrapperElement);

      var priceAfterDiscount = priceCalc(product_discount_object, priceValueInCents);

      var discountElement = document.createElement('span');
      discountElement.style.color = data.strikethrough_price_colors[data.customer.customer_swell_tier];
      price.classList.remove('dynamic-price-final');
      discountElement.classList.add('me-1', 'dynamic-price-discounted', 'dynamic-price-final');
      discountElement.innerText = window.currency.symbol + priceAfterDiscount;

      const parentDiv = price.parentNode;
      if (price.nextSibling) {
        parentDiv.insertBefore(discountElement, price.nextSibling);
      } else {
        parentDiv.appendChild(discountElement);
      }

      price.classList.add('dynamic-price-added');
      if (isCartLine) cartApplyStats.applied++;
      logCartLinePriceDebug('applied-member-price', {
        id: closest_card.id,
        originalCents: priceValueInCents,
        discounted: discountElement.innerText,
        location: price.closest('.cart-item__totals') ? 'line-total' : 'line-details',
      });
    }
  });

  if (cartApplyStats.applied > 0 || cartApplyStats.skipped > 0 || cartApplyStats.reapplied > 0) {
    strikethroughInfo('cart line priceUpdates', {
      ...cartApplyStats,
      lines: summarizeCartLinePrices(),
    });
  }
}

function getStrikethroughData() {
  try {
    const cached = sessionStorage.getItem('strikethrough_data');
    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed && typeof parsed === 'object') return parsed;
    }
  } catch (error) {
    strikethroughWarn('invalid strikethrough_data in sessionStorage', error);
    sessionStorage.removeItem('strikethrough_data');
  }

  return window.strikethrough || null;
}

function refreshStrikethrough() {
  const data = getStrikethroughData();
  if (!data) return;
  initStrikethrough(data);
  if (isCartStrikethroughActive(data)) {
    watchSubtotalMutations();
  }
}

let strikethroughRefreshTimer = null;
let strikethroughDeferredForPromo = false;

function isPromoCartSyncActive() {
  return typeof PromoCartSync !== 'undefined' && PromoCartSync.isLocked();
}

function schedulePostPromoStrikethroughRefresh() {
  if (!strikethroughDeferredForPromo) return;
  strikethroughDeferredForPromo = false;
  strikethroughInfo('promo sync idle → running deferred refresh');
  scheduleRefreshStrikethrough('promo-idle', { skipPromoDefer: true });
}

window.schedulePostPromoStrikethroughRefresh = schedulePostPromoStrikethroughRefresh;

function isCartItemPriceLoading(cartItem) {
  const totalsCell = cartItem.querySelector('.cart-item__totals');
  if (!totalsCell) return false;

  const spinner = totalsCell.querySelector('.loading__spinner');
  return Boolean(spinner && !spinner.classList.contains('hidden'));
}

function getDynamicPriceCents(priceEl, cartItem) {
  if (cartItem && priceEl.closest('.cart-item__totals')) {
    const originalFromData = parseInt(cartItem.dataset.originalLineCents, 10);
    if (!isNaN(originalFromData) && originalFromData > 0) {
      return originalFromData;
    }
  }

  const priceText = (priceEl.textContent || priceEl.innerHTML || '').trim().replace(/^from\s+/i, '');
  if (!priceText) return 0;

  const parsed = parseFloat(priceText.replace(window.currency.symbol, '').replace(/,/g, ''));
  if (isNaN(parsed) || parsed <= 0) return 0;

  return Math.round(parsed * 100);
}

function cartLineMemberPriceNeedsApply(cartItem) {
  if (!cartItem.classList.contains('strikethrough-enabled')) return false;

  const data = getStrikethroughData();
  const totalsCell = cartItem.querySelector('.cart-item__totals');
  if (totalsCell && data && !cartLineTotalMemberPriceIsCorrect(cartItem, totalsCell, data)) {
    return true;
  }

  return Array.from(cartItem.querySelectorAll('.cart-item__details .dynamic-price')).some((priceEl) => {
    if (priceEl.tagName === 'S') return false;
    return !cartLineMemberPriceIsVisible(priceEl, cartItem);
  });
}

function cartDrawerStrikethroughNeedsApply() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return false;

  const itemsRoot = getCartItemsRoot(cartDrawer);
  if (itemsRoot) {
    const lineNeedsApply = Array.from(itemsRoot.querySelectorAll('.cart-item')).some(cartLineMemberPriceNeedsApply);
    if (lineNeedsApply) return true;
  }

  return cartDrawerSubtotalNeedsApply();
}

function cartDrawerSubtotalNeedsApply() {
  if (!isCartStrikethroughActive()) return false;

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return false;

  const subtotal = cartDrawer.querySelector('.cart-drawer__footer .dynamic-subtotal');
  if (!subtotal) return false;

  if (subtotal.querySelector('.strikethrough-subtotal-prices')) return false;

  const itemsRoot = getCartItemsRoot(cartDrawer);
  if (!itemsRoot) return false;

  return Boolean(itemsRoot.querySelector('.cart-item.strikethrough-enabled'));
}

function refreshCartDrawerStrikethroughIfNeeded(source) {
  if (!isCartStrikethroughActive()) return;

  if (isPromoCartSyncActive()) {
    strikethroughInfo('cart strikethrough refresh deferred until promo idle', { source });
    strikethroughDeferredForPromo = true;
    return;
  }

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  if (!cartDrawerStrikethroughNeedsApply()) {
    strikethroughInfo('cart strikethrough refresh skipped', {
      source,
      cartLines: summarizeCartLinePrices(),
    });
    return;
  }

  strikethroughInfo('cart drawer strikethrough refresh', {
    source,
    cartLines: summarizeCartLinePrices(),
  });
  refreshStrikethrough();
}

function scheduleStrikethroughCascade(source, delays = [300, 800, 1500]) {
  if (!isCartStrikethroughActive()) return;

  if (isPromoCartSyncActive()) {
    strikethroughInfo('cascade deferred until promo idle', { source });
    strikethroughDeferredForPromo = true;
    return;
  }

  strikethroughInfo('cart update → schedule cascade', { source, delays });

  delays.forEach((delay) => {
    setTimeout(() => {
      if (!isCartStrikethroughActive()) return;
      if (isPromoCartSyncActive()) {
        strikethroughDeferredForPromo = true;
        return;
      }

      strikethroughInfo('cascade refresh running', {
        source,
        delay,
        cartLines: summarizeCartLinePrices(),
      });
      refreshStrikethrough();
    }, delay);
  });
}

function scheduleRefreshStrikethrough(source, options = {}) {
  if (!options.skipPromoDefer && isPromoCartSyncActive()) {
    strikethroughInfo('refresh deferred until promo idle', { source });
    strikethroughDeferredForPromo = true;
    return;
  }

  strikethroughInfo('cart update → schedule refresh', { source });
  if (strikethroughRefreshTimer) {
    clearTimeout(strikethroughRefreshTimer);
  }
  strikethroughRefreshTimer = setTimeout(() => {
    strikethroughRefreshTimer = null;

    if (isPromoCartSyncActive()) {
      strikethroughInfo('refresh deferred at runtime until promo idle', { source });
      strikethroughDeferredForPromo = true;
      return;
    }

    strikethroughInfo('cart update → running scheduled refresh', { source });
    refreshStrikethrough();
    scheduleStrikethroughCascade(source, [400, 1000]);
  }, 150);
}

// Backwards-compatible alias used by cart-drawer.js and cart.js
function refreshCartDrawerSubtotalIfNeeded(source) {
  refreshCartDrawerStrikethroughIfNeeded(source);
}

function watchCartDrawerLinePrices() {
  if (document.__strikethroughCartLineWatch) return;
  document.__strikethroughCartLineWatch = true;

  const bindItemsWatch = () => {
    if (!isCartStrikethroughActive()) return;

    const itemsRoot =
      document.querySelector('cart-drawer-items') ||
      document.getElementById('CartDrawer-CartItems');

    if (!itemsRoot || itemsRoot.__strikethroughLineObserved) return;

    itemsRoot.__strikethroughLineObserved = true;

    const observer = new MutationObserver(() => {
      if (!isCartStrikethroughActive()) return;

      const strikethroughLines = itemsRoot.querySelectorAll('.cart-item.strikethrough-enabled');
      if (!strikethroughLines.length) return;

      const needsApply = Array.from(strikethroughLines).some(cartLineMemberPriceNeedsApply);
      if (!needsApply) return;

      strikethroughWarn('cart line member price missing after DOM change', {
        cartLines: summarizeCartLinePrices(),
      });
      scheduleRefreshStrikethrough('cart-line-mutation');
    });

    observer.observe(itemsRoot, { childList: true, subtree: true, characterData: true });
    strikethroughInfo('watching cart lines for member price resets');
  };

  bindItemsWatch();
  document.addEventListener('DOMContentLoaded', bindItemsWatch);

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && !cartDrawer.__strikethroughItemsRootWatch) {
    cartDrawer.__strikethroughItemsRootWatch = true;
    const rootObserver = new MutationObserver(() => bindItemsWatch());
    rootObserver.observe(cartDrawer, { childList: true, subtree: true });
  }
}

function watchCartDrawerForSubtotalReset() {
  if (document.__strikethroughCartDrawerWatch) return;
  document.__strikethroughCartDrawerWatch = true;

  const attach = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    let watchedFooter = null;

    const bindFooterWatch = () => {
      if (!isCartStrikethroughActive()) return;

      const footer = cartDrawer.querySelector('.cart-drawer__footer');
      if (!footer || footer === watchedFooter) return;

      watchedFooter = footer;
      const footerObserver = new MutationObserver((mutations) => {
        if (!isCartStrikethroughActive()) return;
        if (!mutations.some((m) => m.type === 'childList')) return;
        refreshCartDrawerSubtotalIfNeeded('footer-childList');
      });
      footerObserver.observe(footer, { childList: true, subtree: true });
    };

    bindFooterWatch();

    const rootObserver = new MutationObserver((mutations) => {
      if (!isCartStrikethroughActive()) return;
      if (!mutations.some((m) => m.type === 'childList')) return;
      bindFooterWatch();
      refreshCartDrawerSubtotalIfNeeded('cart-drawer-structure');
    });
    rootObserver.observe(cartDrawer, { childList: true, subtree: true });

    strikethroughInfo('watching cart-drawer for subtotal resets');
  };

  if (document.querySelector('cart-drawer')) attach();
  else document.addEventListener('DOMContentLoaded', attach);
}

function watchSubtotalMutations() {
  if (!isCartStrikethroughActive()) return;

  document.querySelectorAll('.dynamic-subtotal').forEach((el) => {
    if (el.__strikethroughObserved) return;
    el.__strikethroughObserved = true;
    let hadStrikethrough = el.classList.contains('dynamic-subtotal-added');

    const observer = new MutationObserver(() => {
      if (!isCartStrikethroughActive()) return;

      const hasStrikethrough = el.classList.contains('dynamic-subtotal-added');
      if (hadStrikethrough && !hasStrikethrough) {
        strikethroughWarn('subtotal strikethrough was erased', {
          text: el.textContent.trim(),
          html: el.innerHTML.trim().slice(0, 160),
        });
      }
      hadStrikethrough = hasStrikethrough;

      if (window.strikethroughDebug) {
        strikethroughInfo('subtotal DOM changed', {
          hasStrikethrough,
          text: el.textContent.trim(),
        });
      }
    });

    observer.observe(el, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  });
}

function logCartDomReplace(source, selector) {
  strikethroughInfo('cart DOM replaced', {
    source,
    selector,
    cartLines: summarizeCartLinePrices(),
  });

  // Cart DOM rewrites are only relevant to member cart strikethrough.
  if (!isCartStrikethroughActive()) return;

  if (isPromoCartSyncActive()) {
    strikethroughInfo('DOM replace strikethrough deferred until promo idle', { source, selector });
    strikethroughDeferredForPromo = true;
    return;
  }

  scheduleRefreshStrikethrough(source + ':' + (selector || 'unknown'));
  scheduleStrikethroughCascade(source + ':' + (selector || 'unknown'), [0, 300, 800, 1500, 2500]);
}
function initStrikethrough(data) {
  if (!data || !data.customer) {
    // strikethroughLog('initStrikethrough aborted', 'invalid or missing data');
    strikethroughWarn('init aborted', 'invalid or missing data');
    return;
  }

  data.customer.customer_swell_tier = normalizeSwellTier(data.customer.customer_swell_tier);

  // strikethroughLog('initStrikethrough called', {
  //   swellTier: data.customer.customer_swell_tier,
  //   loggedIn: data.customer.customer_logged_in,
  //   enableLoggedOut: data.strikethrough_enable_logged_out,
  //   customerTypes: data.strikethrough_customer_types,
  //   productTypesForTier: data.strikethrough_product_types?.[data.customer.customer_swell_tier],
  // });

  if (!data.customer.customer_swell_tier) {
    // strikethroughLog('initStrikethrough aborted', 'no customer_swell_tier');
    strikethroughWarn('init aborted', 'no customer_swell_tier');
    return;
  }

  var body = document.querySelector('body');
  body.dataset.swellUser = 'swell-' + data.customer.customer_swell_tier;

  let customer_is_eligible = eligibilityCheck(data);

  // strikethroughLog('eligibility', { customer_is_eligible });
  strikethroughInfo('init', {
    swellTier: data.customer.customer_swell_tier,
    eligible: customer_is_eligible,
    loggedIn: data.customer.customer_logged_in,
    enableLoggedOut: data.strikethrough_enable_logged_out,
    customerTypes: data.strikethrough_customer_types,
    surfaces: data.strikethrough_surfaces,
  });

  if (customer_is_eligible) priceUpdates(data);
  if (customer_is_eligible) applyStrikethroughBadges(data);
  if (customer_is_eligible && isStrikethroughSurfaceEnabled(data, 'cart')) {
    applyCartDetailMemberPriceColors(data);
    applyCartLineTotalPrices(data);
    subTotalUpdates(data);
  }

  if (window.strikethroughDebug) {
    logCartLinePriceDebug('after-priceUpdates', summarizeCartLinePrices());
  }
}

function applyCartDetailMemberPriceColors(data) {
  const priceColor = data?.strikethrough_price_colors?.[data.customer?.customer_swell_tier];
  if (!priceColor) return;

  // Shopify-discounted unit prices under the title use .price--new (not .dynamic-price-discounted).
  // priceUpdates skips <s class="dynamic-price">, so color them here for cart drawer + cart page.
  document
    .querySelectorAll(
      '.cart-item.strikethrough-enabled .cart-item__details .price--new, .cart-item.strikethrough-enabled .cart-item__details .dynamic-price-discounted'
    )
    .forEach((el) => {
      el.style.color = priceColor;
    });
}

function eligibilityCheck(data) {
  if (data.strikethrough_enable_logged_out) {
    return true;
  } else {
    if (!data.customer.customer_logged_in) return false;

    return data.strikethrough_customer_types.includes(data.customer.customer_swell_tier);
  }
}

function deepEqual(obj1, obj2) {
  if (obj1 === obj2) return true;

  if (obj1 == null || obj2 == null) return false;
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;

  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) return false;
  }

  return true;
}


var strikethrough_data = sessionStorage.getItem('strikethrough_data');
var objects_are_same = JSON.stringify(window.strikethrough) === strikethrough_data;

// console.log('strikethrough_data SESSION', strikethrough_data)

if(!strikethrough_data){
  strikethroughInfo('waiting for swell:setup', 'no strikethrough_data in sessionStorage yet');

  (function () {

    $(document).ready(function () {
      $(document).on("swell:setup", async () => {

        // console.log('Refreshing swell data................................')

        sessionStorage.removeItem('strikethrough_data');
        var customerDetails = await swellAPI.getCustomerDetails();

        window.strikethrough.customer.customer_swell_tier = normalizeSwellTier(
          customerDetails.vipTier ? customerDetails.vipTier.name : 'regular'
        );
        window.strikethrough.customer.customer_email = customerDetails.email || '';

        var strikethrough_session_data = JSON.stringify(window.strikethrough);
        sessionStorage.setItem('strikethrough_data', strikethrough_session_data);

        strikethroughInfo('swell:setup complete', { tier: window.strikethrough.customer.customer_swell_tier });
        refreshStrikethrough();
        document.dispatchEvent(new CustomEvent('strikethrough:swell-updated', {
          detail: {
            tier: window.strikethrough.customer.customer_swell_tier,
            email: window.strikethrough.customer.customer_email,
          },
        }));

      });
    });

  }).call(this);
  
} else {
  strikethroughInfo('using cached strikethrough_data from sessionStorage');
  try {
    const cached = JSON.parse(strikethrough_data);
    if (window.strikethrough && cached) {
      cached.strikethrough_product_types = window.strikethrough.strikethrough_product_types;
      cached.strikethrough_badge_enable = window.strikethrough.strikethrough_badge_enable;
      cached.strikethrough_badge_colors = window.strikethrough.strikethrough_badge_colors;
      cached.strikethrough_price_colors = window.strikethrough.strikethrough_price_colors;
      cached.strikethrough_enable_logged_out = window.strikethrough.strikethrough_enable_logged_out;
      cached.strikethrough_customer_types = window.strikethrough.strikethrough_customer_types;
      cached.strikethrough_surfaces = window.strikethrough.strikethrough_surfaces;
      sessionStorage.setItem('strikethrough_data', JSON.stringify(cached));
    }
  } catch (error) {
    strikethroughWarn('failed to merge cached strikethrough_data with theme settings', error);
  }
  refreshStrikethrough();
}

strikethroughInfo('script loaded', {
  version: '2026-07-24g',
  debugVerbose: 'set window.strikethroughDebug = true before add-to-cart for cart line logs',
});

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    strikethroughInfo('cart update event received', {
      source: event?.source,
      variantId: event?.productVariantId || event?.variantId,
    });
    scheduleRefreshStrikethrough('pubsub:' + (event?.source || 'unknown'));
  });
}

// Cart mutation watchers only matter when member cart strikethrough can run.
// Shopify discount compare-at is Liquid-only and must not be observed/rewritten here.
if (isCartStrikethroughConfigured()) {
  watchSubtotalMutations();
  watchCartDrawerForSubtotalReset();
  watchCartDrawerLinePrices();
}

window.summarizeCartLinePrices = summarizeCartLinePrices;


/* Lets start, and we need to refactor this at some point */

// var logged_changed = false;
// var prev_logged_in_status = sessionStorage.getItem('logged_in_status');
// var current_logged_in_status = window.logged.logged_in_status;

// if (!prev_logged_in_status) {
//   sessionStorage.setItem('logged_in_status', current_logged_in_status);
// } else {
//   sessionStorage.setItem('logged_in_status', current_logged_in_status);
//   var new_logged_in_status = sessionStorage.getItem('logged_in_status');
//   if (prev_logged_in_status !== new_logged_in_status) {
//     logged_changed = true;
//   }
// }



// if (!strikethrough_data || logged_changed || !objects_are_same) {

//   console.log('DATA', strikethrough_data)

//   if (window.strikethrough.strikethrough_customer_types.length === 1 && window.strikethrough.strikethrough_customer_types.includes('regular')) {
//     sessionStorage.removeItem('strikethrough_data');
//     window.strikethrough.customer.customer_swell_tier = 'regular';
//     window.strikethrough.customer.customer_email = '';

//     var strikethrough_session_data = JSON.stringify(window.strikethrough);
//     sessionStorage.setItem('strikethrough_data', strikethrough_session_data);
//     strikethrough_data = JSON.parse(sessionStorage.getItem('strikethrough_data'));

//     console.log('SWELL DATAAAAAAAAAAAAA', strikethrough_data)
//     initStrikethrough(strikethrough_data);
//   } else {

//   }
// } else {
//   strikethrough_data = JSON.parse(sessionStorage.getItem('strikethrough_data'));

//   console.log('SWELL DATAAAAAAAAAAAAA', strikethrough_data)
//   initStrikethrough(strikethrough_data);
// }

